import { JdSearch } from '../jdSearch';


export class JdSearchSerializer {
    fromJson(json: any): JdSearch {
        return json;
    }

    toJson(data: JdSearch): any {
        return {
            id: data.id,
            name: data.name,
            description: data.description,
        };
    }
}